'use strict';

var coreUtilityAliases = require('../var/coreUtilityAliases');

var classToString = coreUtilityAliases.classToString;

function isClass(obj, className, str) {
  if (!str) {
    str = classToString(obj);
  }
  return str === '[object '+ className +']';
}

module.exports = isClass;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/common/internal/isClass.js
// module id = 85
// module chunks = 1